<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs pos-relative r5-devices r11_screenshots"
	style="min-height: 23em"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="c-portlet o-block u-width-100p _u-width-100p stats-container">
		<div class="o-stack__cell">
			<h5 class="title primary-color">{{ sectiontitle }}</h5>
		</div>
	</div>
	<div class="screenshotscontent" *ngIf="screenshotsArray.length > 0 && hasData; else noScreenshotsBlock">
		<div class="screens-outer-div">
			<div
				class="screenshot_div"
				*ngFor="let screenshot of screenshotsArray | paginate: { itemsPerPage: 20, currentPage: p2 }; index as i"
			>
				<div
					class="screenshot_image"
					(click)="previewScreenshot(screenshot.imageURL)"
					[ngStyle]="{ 'background-image': 'url(' + screenshot.imageURL + ')' }"
				></div>
				<div class="screenshot_info">
					<div class="screenshot_url">{{ screenshot.url }}</div>
					<div class="screenshot_timestamp" (click)="previewScreenshot(screenshot.imageURL)">{{ screenshot.date }}</div>
				</div>
			</div>
		</div>

		<pagination-template
			#p="paginationApi"
			(pageChange)="p2 = $event"
			class="cox_pagination r11_pagination"
			*ngIf="screenshotsArray.length > 20"
		>
			<ul class="pager">
				<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow">
					<a (click)="p.setCurrent(1)">
						<i class="fa fa-step-backward icons"></i>
					</a>
				</li>
				<li [class.disabled]="p.isFirstPage()" style="float: left">
					<a (click)="p.previous()">
						<img class="arrow_image" src="../../../../../assets/partner-assets/default-r5/icons/left_arrow.png" />
					</a>
				</li>
				<li
					role="button"
					*ngFor="let page of p.pages"
					[class.current]="p.getCurrent() === page.value"
					class="pages"
					style="float: left"
				>
					<a
						(click)="p.setCurrent(page.value)"
						*ngIf="p.getCurrent() !== page.value"
						[class.primary-color-bg-on-hover]="p.getCurrent() !== page.value"
					>
						{{ page.label }}
					</a>
					<a *ngIf="p.getCurrent() === page.value" [class.primary-color-bg]="p.getCurrent() === page.value">
						{{ page.label }}
					</a>
				</li>
				<li [class.disabled]="p.isLastPage()" style="float: left">
					<a (click)="p.next()">
						<img class="arrow_image" src="../../../../../assets/partner-assets/default-r5/icons/right_arrow.png" />
					</a>
				</li>
				<li [class.disabled]="p.isLastPage()" style="float: left" class="lastArrow">
					<a (click)="p.setCurrent(p.getLastPage())">
						<i class="fa fa-step-forward icons"></i>
					</a>
				</li>
			</ul>
		</pagination-template>
	</div>
	<ng-template #noScreenshotsBlock>
		<div class="no-screenshots-data">
			<p>No Data to Display</p>
		</div>
	</ng-template>
</div>
